import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import T from 'i18n-react';
import { Pill } from '@adsk/bim360-matrix-react-components';

const StatusPill = ({ status, className }) => {
  const pillClasses = cx('StatusPill', className, `IssueStatus__${status}`);

  return (
    <Pill className={pillClasses} label={T.translate(`status.${status}`)} />
  );
};

StatusPill.displayName = 'StatusPill';

StatusPill.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default StatusPill;
